export const appShellSidebar = 'app-shell-sidebar';
export const sidebarChangeLanguageButton = 'sidebar-change-language-button';
export const sidebarSwitchCompanyButton = 'sidebar-switch-company-button';
export const sidebarLogo = 'sidebar-logo';
export const sidebarProfileButton = 'sidebar-profile-button';
export const sidebarHomeButton = 'sidebar-home-button';
export const sidebarHelpButton = 'sidebar-help-button';
export const sidebarQredVisaLink = 'sidebar-qred-visa-link';
export const sidebarBecomeTesterLink = 'sidebar-become-tester-link';
